import React from 'react';
import { createRoot } from 'react-dom/client';
import TagManager from 'react-gtm-module'; // Krok 1: Import biblioteki
import './index.css';
import App from './App';

// Krok 2: Konfiguracja GTM z Twoim ID
const tagManagerArgs = {
  gtmId: 'GTM-TZDTSVKC'
};

// Krok 3: Inicjalizacja GTM
TagManager.initialize(tagManagerArgs);

// Get the root element
const container = document.getElementById('root');

// Create root only if container exists
if (container) {
  const root = createRoot(container);

  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  console.error('Root element not found');
}